__turbopack_context__.v({
  "bootRaster": "ReferenceRaster-module__NQe5Xq__bootRaster",
  "canvas": "ReferenceRaster-module__NQe5Xq__canvas",
  "fadeIn": "ReferenceRaster-module__NQe5Xq__fadeIn",
  "fadeOut": "ReferenceRaster-module__NQe5Xq__fadeOut",
  "hitMap": "ReferenceRaster-module__NQe5Xq__hitMap",
  "hotspot": "ReferenceRaster-module__NQe5Xq__hotspot",
  "image": "ReferenceRaster-module__NQe5Xq__image",
  "insets": "ReferenceRaster-module__NQe5Xq__insets",
  "neon": "ReferenceRaster-module__NQe5Xq__neon",
  "pulse": "ReferenceRaster-module__NQe5Xq__pulse",
  "rasterIn": "ReferenceRaster-module__NQe5Xq__rasterIn",
  "rasterOut": "ReferenceRaster-module__NQe5Xq__rasterOut",
  "sonar": "ReferenceRaster-module__NQe5Xq__sonar",
  "spark": "ReferenceRaster-module__NQe5Xq__spark",
});
